import { ServiceClient } from 'src/utils'
import { NotificationType } from '../user-manager/um_scopes'

const serviceClient = ServiceClient.singleton()

export class NotificationTypesManagerService {
    static #INSTANCE = new NotificationTypesManagerService()
    static readonly singleton = () => NotificationTypesManagerService.#INSTANCE

    async fetchAll(activeOnly = true): Promise<NotificationType[]> {
        return serviceClient.authGet<NotificationType[]>(`/api/notification-types?activeOnly=${activeOnly}`)
    }

    async create(type: NotificationType): Promise<NotificationType> {
        return serviceClient.authPost<NotificationType>('/api/notification-types', type)
    }

    async update(typeId: number, type: NotificationType): Promise<NotificationType> {
        return serviceClient.authPut<NotificationType>(`/api/notification-types/${typeId}`, type)
    }

    async delete(typeId: number): Promise<void> {
        await serviceClient.authDelete(`/api/notification-types/${typeId}`)
    }
}

export default NotificationTypesManagerService.singleton()
